import React, { Component } from 'react';
import ReadAxios from "../axiosComponent/read";
import isEmpty from "lodash/isEmpty";

export default class Vehicletyperenderer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      vehicleType: [],
    };
  }

  async componentDidMount() {
    let vehicle_type = this.props.data.proposed_vehicle_type ? this.props.data.proposed_vehicle_type : this.props.data.vehicle_type
    let dataArray =
      (await ReadAxios({
        url: `vehicleTypeMaster/${vehicle_type}`,
      })) || [];
    dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    this.setState({ vehicleType: dataArray || [] });
  }
  render() {
    const { t } = this.props;
    const { vehicleType } = this.state;
    return (
      <div>
        <span>{vehicleType.length > 0 ? vehicleType[0].vehicleType + " " + "(" + vehicleType[0].vehicleTypeTonnage + ")" : "NA"}</span>
      </div>
    )
  }
}
